<!--
  ~ Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
  ~ Venelin Iliev <http://veneliniliev.com>
  -->

<button type="button" class="btn btn-info btn-ico" [ngbTooltip]="'SEO_BUTTON.SEO' | translate" container="body">
  <i class="fal fa-chart-line"></i>
</button>
